/**
 * Small pulsing dot + "Live" label used by the auto-refreshing admin
 * pages so operators can tell at a glance that the data is current.
 */
export default function LiveBadge({ label = 'Live', intervalMs = 5000 }) {
  const seconds = Math.round(intervalMs / 1000);
  return (
    <div
      className="inline-flex items-center gap-1.5 text-[10px] font-semibold tracking-wider uppercase text-emerald-400"
      title={`Auto-refreshing every ${seconds}s`}
      data-testid="live-badge"
    >
      <span className="relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-70 animate-ping" />
        <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
      </span>
      {label}
    </div>
  );
}
